import React, { useState } from 'react';
import { publishMedicationList, unpublishMedicationList } from '../../Async/MedicationListsAsync';
import { Button, ButtonSize } from '../../Components/Button';
import { LockedPadlockIcon, UnlockedPadlockIcon } from '../../Components/Icons';
import { displayError } from '../../Config/ApplicationConfig';
import { MedicationListResponse } from '../../Contracts/MedicationList.Response';
import { MedicationListStatus } from '../../Contracts/MedicationListsSearchFilter.Request';
import { getFirstErrorMessageFromApiError } from '../../Shared/DomainValidationFunctions';
import { white } from '../../Styles/Colours';
import styles from './PublishButton.module.scss';

export function PublishButton(props: {
    currentMedicationList: MedicationListResponse;
    disabled: boolean;
    onToggled(published: boolean): void;
}) {
    const [togglingState, setTogglingState] = useState(false);
    const draft = props.currentMedicationList.status === MedicationListStatus.Draft;

    const handlePublishClick = async () => {
        setTogglingState(true);
        try {
            if (draft) {
                await publishMedicationList(props.currentMedicationList.id);
                props.onToggled(true);
            } else {
                await unpublishMedicationList(props.currentMedicationList.id);
                props.onToggled(false);
            }
        } catch (e) {
            const error = getFirstErrorMessageFromApiError(e);
            displayError(error);
        }
        setTogglingState(false);
    };
    return (
        <div className={styles.publishContainer}>
            <Button
                testId={'publish'}
                size={ButtonSize.small}
                onClick={handlePublishClick}
                disabled={togglingState || props.disabled}
                startIcon={
                    draft ? (
                        <LockedPadlockIcon noPadding size={'20'} color={white} />
                    ) : (
                        <UnlockedPadlockIcon noPadding size={'20'} color={white} />
                    )
                }
            >
                {draft ? 'Publish' : 'Unpublish'}
            </Button>
        </div>
    );
}
